export default function IconLinkArrow() {
  return (
    <svg width="15" height="6" viewBox="0 0 15 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.24 5.8C10.3733 5.45333 10.52 5.13333 10.68 4.84C10.84 4.53333 11.02 4.24667 11.22 3.98H0.5V2.34H11.22C11.0333 2.07333 10.86 1.79333 10.7 1.5C10.54 1.19333 10.3933 0.866666 10.26 0.519999H11.78C12.6067 1.49333 13.5133 2.23333 14.5 2.74V3.6C13.5133 4.08 12.6067 4.81333 11.78 5.8H10.24Z"
        fill="#85929A"/>
    </svg>
  )
}
